<div>
  <div class="d-flex justify-content-center align-items-center mt-3">

    <!-- Botones tipo "punto" -->
    <button class="dot-btn" [class.active]="op === 1" (click)="op = 1"></button>
    <button class="dot-btn" [class.active]="op === 2" (click)="op = 2"></button>
  </div>


<div *ngIf="op==2">
  <app-view-group [data]="dataGroup" ></app-view-group>
</div>

<div class="cost-distribution" *ngIf="op==1">
  <!-- Header -->
  <!-- <div class="page-header">
    <h1 class="page-title">
      <i class="fas fa-chart-pie"></i>
      Reparto de costes
    </h1>
    <p class="page-subtitle">Análisis y distribución de costes energéticos por grupo y dispositivo</p>
  </div> -->

  <!-- Filtros de tiempo -->
  <app-filters-time
    [priceKwh]="priceKwh"
    [activeFilter]="activeFilter"
    [customStartDate]="customStartDate"
    [customEndDate]="customEndDate"
    (filterChange)="onFilterChange($event)"
    (customDateChange)="onCustomDateChange($event)"
    (priceChange)="savePrice()"
    (monthSelected)="onMonthSelected($event)">
  </app-filters-time>

  <!-- Sección Subgrupos -->
  <div class="card mb-3 shadow-sm" *ngIf="subgroups && subgroups.length > 0">
    <div class="card-header p-3 bg-dark text-white d-flex align-items-center justify-content-between cursor-pointer user-select-none my-rounded mb-0"
         (click)="toggleAccordion('subgroups')">
      <div class="d-flex align-items-center gap-3">
        <i class="fas fa-chevron-right transition-transform"
           [class.rotate-90]="subgroupsExpanded"></i>
        <span class="fw-semibold fs-4">{{"subgroups" | translate }} ({{subgroups.length}})</span>
      </div>
    </div>

    <div class="collapse" [class.show]="subgroupsExpanded">
      <div class="card-body p-4">
        <div class="row g-3">

          <!-- tarjeta de subgrupo -->
          <div class="col-12 col-md-6 col-lg-4 col-xl-3"
               *ngFor="let subgroup of subgroups; let i = index">
            <label class="card h-100 border-2 cursor-pointer"
                   [class.border-primary]="isSubgroupSelected(subgroup.alias)"
                   [class.bg-primary-subtle]="isSubgroupSelected(subgroup.alias)">

              <!-- checkbox fantasma -->
              <input type="checkbox" class="d-none"
                     [checked]="isSubgroupSelected(subgroup.alias)"
                     (change)="onSubgroupSelectionChange($event, subgroup.alias)">

              <div class="card-body d-flex flex-column">
                <!-- cabecera -->
                <h6 class="card-title fw-semibold mb-2">{{ subgroup.name }}</h6>
                <p class="card-text text-muted small mb-2">{{ subgroup.description }}</p>
                <p class="card-text text-muted small mb-3">
                  {{ subgroup.devices?.length }} {{ 'devices' | translate }}
                </p>

                <!-- botón -->
                <button class="btn btn-primary btn-sm mt-auto"
                        (click)="$event.stopPropagation(); toggleSubgroupDetails(i)">
                  {{ (subgroup.showDetails ? 'hideDetails' : 'moreDetails') | translate }}
                </button>

                <!-- lista de dispositivos -->
                <ul *ngIf="subgroup.showDetails" class="list-unstyled mt-3 small">
                  <li *ngFor="let d of subgroup.devices" class="mb-2 pb-2 border-bottom">
                    <div class="fw-medium">{{ d.name || '—' }}</div>
                    <div class="text-muted">{{ d.serial }}</div>
                    <div class="text-muted">{{ d.total / 1000 }} kWh</div>
                  </li>
                </ul>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sección Cargadores -->
  <div class="card mb-3 shadow-sm">
    <div class="card-header p-3 bg-dark text-white d-flex align-items-center justify-content-between cursor-pointer user-select-none my-rounded mb-0"
      (click)="toggleAccordion('chargers')">
      <div class="d-flex align-items-center gap-3">
        <i class="fas fa-chevron-right transition-transform"
        [class.rotate-90]="chargersExpanded"></i>
        <span class="fw-semibold fs-4">{{ "devices" | translate }} ({{allChargers.length}})</span>
      </div>
    </div>

    <div class="collapse" [class.show]="chargersExpanded">
      <div class="card-body p-4">
        <!-- Controles de vista -->
        <div class="d-flex justify-content-between align-items-center pb-3 border-bottom mb-3">
          <label class="checkbox-container">
            <!-- TEMPLATE -->
            <input type="checkbox" [checked]="isAllSelected" [indeterminate]="isIndeterminate"
              (change)="onSelectAllChange($event)">

            <span class="checkmark"></span>
              {{ "selectAll" | translate}}
          </label>

          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn"
                    [class.btn-primary]="currentView === 'list'"
                    [class.btn-outline-primary]="currentView !== 'list'"
                    (click)="onViewChange('list')">
              <i class="fas fa-list me-1"></i>
              {{ "deviceListing" | translate}}
            </button>
            <button type="button" class="btn"
                    [class.btn-primary]="currentView === 'grid'"
                    [class.btn-outline-primary]="currentView !== 'grid'"
                    (click)="onViewChange('grid')">
              <i class="fas fa-th-large me-1"></i>
              {{"cards_s" | translate }}
            </button>
          </div>
        </div>

        <div class="mb-3">
          <span class="text-muted small">
            <strong>{{selectedChargerIds.length}}</strong> de {{allChargers.length}} {{ "valuesSelected" | translate }}
          </span>
        </div>

        <!-- Vista listado -->
        <div class="chargers-list" *ngIf="currentView === 'list'">
          <div class="charger-item" *ngFor="let charger of allChargers; let i = index"
            [class.selected]="isChargerSelected(charger.serial)">
            <label class="checkbox-container">
              <input type="checkbox" [checked]="isChargerSelected(charger.serial)"
                (change)="onChargerSelectionChange($event, charger.serial)">
              <span class="checkmark"></span>
            </label>
            <div (click)="goToDevice(charger.serial)" style="cursor: pointer;"
              class="d-flex justify-content-center p-1">
              <img *ngIf="charger.serial.includes('EVVC3')" src="./../../../../assets/img/orbis/uni.png" alt=""
                style="height: 45px;">
              <img *ngIf="charger.serial.includes('EVVC4')" src="./../../../../assets/img/orbis/combiplus.png" alt=""
                style="height: 45px;">
              <img *ngIf="charger.serial.includes('EVVC5')" src="./../../../../assets/img/orbis/city+2.png" alt=""
                style="height: 45px;">
              <img *ngIf="charger.serial.includes('EVVC1')" src="./../../../../assets/img/orbis/combi.png" alt=""
                style="height: 45px;">
              <img *ngIf="charger.serial.includes('EVVC6')" src="./../../../../assets/img/orbis/exo.png" alt=""
                style="height: 40px;">
            </div>
            <div class="charger-info">
              <div class="charger-name">{{ charger.name ? charger.name : charger.serial}}</div>
              <div class="charger-code">{{charger.serial}}</div>
            </div>
            <div class="charger-status">
              <span class="status-badge" [ngClass]="getStatusClass(charger.alive)">
                {{getStatusText(charger.alive)}}
              </span>
            </div>
            <div class="charger-data">
              <div class="data-item">
                <i class="fas fa-calendar"></i>
                <span class="data-value">{{ charger.historic?.[i]?.end_datetime ? (charger.historic?.[i]?.end_datetime | date:'dd/MM/yyyy') :  '--/--/--'}}</span>
              </div>
              <div class="data-item">
                <i class="fas fa-bolt"></i>
                <span class="data-value">{{charger.total / 1000 | number:'1.2-2'}} kWh</span>
              </div>
            </div>
            <div class="charger-actions">

              <button class="action-btn" title="Ver gráficos" (click)="getHistoricGraph(charger.serial, i)" data-toggle="modal"  data-target="#ModalGraphics">
                <i class="fas fa-chart-line"></i>
              </button>

              <button class="action-btn" title="Historial" (click)="getDataHistoric(charger.serial, i)" data-toggle="modal"  data-target="#modalHistoric">
                <i class="fas fa-history"></i>
              </button>

            </div>
          </div>
        </div>

        <!-- Vista tarjetas -->
        <div class="chargers-grid" *ngIf="currentView === 'grid'">
          <div class="charger-card" *ngFor="let charger of allChargers; let i = index"
            [class.selected]="isChargerSelected(charger.serial)">

            <!-- Checkbox -->
            <label class="checkbox-container card-checkbox">
              <input type="checkbox" [checked]="isChargerSelected(charger.serial)"
                (change)="onChargerSelectionChange($event, charger.serial!)">
              <span class="checkmark"></span>
            </label>

            <!-- Cabecera con nombre/serial + imagen y estado -->
            <div class="charger-card-header">
              <!-- Nombre, estado y serial -->
              <div>
            <div class="d-flex align-items-center gap-2">
              <span class="card-name">{{ charger.name ? charger.name : charger.serial }}</span>

              <!-- Punto de estado con tooltip -->
              <span
                class="status-dot"
                [ngClass]="getStatusClass(charger.alive)"
                [attr.title]="getStatusText(charger.alive)">
              </span>
            </div>

                <div class="card-code">{{ charger.serial }}</div>
              </div>

              <!-- Imagen -->
              <div class="text-center">
                <img *ngIf="charger.serial.includes('EVVC3')" src="./../../../../assets/img/orbis/uni.png" alt="uni" style="height: 35px;">
                <img *ngIf="charger.serial.includes('EVVC4')" src="./../../../../assets/img/orbis/combiplus.png" alt="combiplus" style="height: 35px;">
                <img *ngIf="charger.serial.includes('EVVC5')" src="./../../../../assets/img/orbis/city+2.png" alt="city+2" style="height: 35px;">
                <img *ngIf="charger.serial.includes('EVVC1')" src="./../../../../assets/img/orbis/combi.png" alt="combi" style="height: 35px;">
                <img *ngIf="charger.serial.includes('EVVC6')" src="./../../../../assets/img/orbis/exo.png" alt="exo" style="height: 35px;">
              </div>
            </div>


            <!-- Datos -->
            <div class="card-data">
              <div class="card-data-item">
                <div class="card-data-label"> {{ "lastCharge" | translate}} </div>
                <div class="card-data-value">{{ charger.historic?.[i]?.end_datetime  ?  (charger.historic?.[i]?.end_datetime | date:'dd/MM/yyyy') :  '--/--/--' }}</div>
              </div>
              <div class="card-data-item">
                <div class="card-data-label"> {{"totalConsumption " | translate}} </div>
                <div class="card-data-value">{{ charger.total / 1000 | number:'1.2-2' }} kWh</div>
              </div>
            </div>

            <!-- Acciones -->
            <div class="card-actions">
              <button class="action-btn" title="Ver gráficos" (click)="getHistoricGraph(charger.serial, i)" data-toggle="modal"  data-target="#ModalGraphics">
                <i class="fas fa-chart-line"></i>
              </button>

              <button class="action-btn" title="Historial" (click)="getDataHistoric(charger.serial, i)" data-toggle="modal"  data-target="#modalHistoric">
                <i class="fas fa-history"></i>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Resumen de selección -->
  <!-- <div class="selection-summary" *ngIf="showSummary"> -->
  <div class="selection-summary">
    <div class="summary-header">
      <i class="fas fa-chart-bar"></i>
      {{ "selectionSummary" | translate}}
    </div>

    <div class="input-group" style="max-width: 350px; position: relative;">
      <!-- Input: solo habilitado si hay campo seleccionado -->
      <input type="text" class="form-control form-control-sm"
        [placeholder]="selectedColumn ? 'Buscar por ' + columnDisplayNames[selectedColumn] : 'selectField'| translate"
        [(ngModel)]="tableSearchText" [disabled]="!selectedColumn" (input)="applyTableFilter()" />

      <!-- Botón: abre el menú de selección de campo -->
      <button type="button" class="input-group-text" (click)="toggleColumnDropdown()">
        <i class="fas fa-filter"></i>
      </button>

      <!-- Dropdown personalizado -->
      <div *ngIf="showColumnDropdown" class="dropdown-menu show "
        style="position: absolute; top: 100%; right: 0; z-index: 10;">
        <button class="dropdown-item" *ngFor="let col of filterableColumns" (click)="selectColumn(col)">
          {{ columnDisplayNames[col] }}
        </button>
      </div>
    </div>

    <!-- Tabla de datos detallados -->
    <div class="data-table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th (click)="onSort('name')" class="sortable">  {{ "name" | translate}}
              <span *ngIf="sortColumn === 'name'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th (click)="onSort('serial')" class="sortable"> {{ "serial_number" | translate }}
              <span *ngIf="sortColumn === 'serial'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th (click)="onSort('start_datetime')" class="sortable"> {{ "startDateTime" | translate}}
              <span *ngIf="sortColumn === 'start_datetime'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th (click)="onSort('end_datetime')" class="sortable"> {{"endDateTime" | translate}}
              <span *ngIf="sortColumn === 'end_datetime'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th (click)="onSort('duration')" class="sortable">{{"duration" | translate}} <br>hh:mm:ss
              <span *ngIf="sortColumn === 'duration'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th (click)="onSort('active')" class="sortable">{{ "energy" | translate}} Wh
              <span *ngIf="sortColumn === 'active'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th (click)="onSort('coste')" class="sortable">{{ "cost" | translate}} €
              <span *ngIf="sortColumn === 'coste'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th (click)="onSort('user')" class="sortable">{{"user" | translate}}
              <span *ngIf="sortColumn === 'user'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th (click)="onSort('element')" class="sortable">{{ "out" | translate}}
              <span *ngIf="sortColumn === 'element'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
          </tr>
        </thead>

        <tbody>
          <!-- <tr *ngFor="let charge of filteredCharges" -->
          <tr *ngFor="let data of paginatedCharges">
            <td>{{ data.name}} </td>
            <td> {{data.serial}}</td>
            <!-- <td>{{formatDateTime(data.start_datetime) |  date:'dd/MM/yyyy HH:mm:ss' }}</td> -->
            <td>{{(data.start_datetime) | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <td>{{(data.end_datetime) | date:'dd/MM/yyyy HH:mm:ss' }}</td>

            <td class="text-center">{{ subtractDates( data.end_datetime,data.start_datetime) }}</td>
            <!-- <td class="text-center">{{data.duration}}</td> -->
            <td class="">{{data.active}}</td>
            <td class="">{{data.active / 1000 * priceKwh| number:'1.2-2'}}</td>
            <td class="">{{data.user }}</td>
            <!-- <td class="">{{data.element}}</td> -->
            <td class="">{{ "connector" | translate  }}  {{ mennekes(data.element)}} </td>
          </tr>
          <tr *ngIf="filteredCharges.length === 0" class="m-1">
            <td colspan="8" style="text-align: center; padding: 20px;" class="m-2">
              {{"noDatafilteredCharges" | translate}}
            </td>
          </tr>

          <tr *ngIf="filteredCharges.length > itemsPerPage">
            <td colspan="12" class="pagination-controls align-middle">
              <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">

                <!-- Selector de cantidad -->
                <div class="form-group d-flex align-items-center mb-0">
                  <label for="itemsPerPage" class="mr-2 mb-0">{{"recordsPerPage" | translate}}:</label>
                  <select id="itemsPerPage" class="form-control form-control-sm w-auto" [(ngModel)]="itemsPerPage"
                    (ngModelChange)="onItemsPerPageChange($event)">
                    <option *ngFor="let size of [10, 25, 50, 100]" [value]="size">{{ size }}</option>
                  </select>
                </div>

                <!-- Input para ir a página -->
                <div class="ml-3 d-flex align-items-center">
                  <label class="mb-0 mr-2" for="goToPageInput">{{"goToPage" | translate}} :</label>
                  <input type="number" class="form-control form-control-sm w-auto" id="goToPageInput"
                    [(ngModel)]="goToPageInput" (keyup.enter)="onGoToPageInputChange()" min="1" [max]="totalPages"
                    style="width: 70px;">
                </div>

                <!-- Botones de paginación -->
                <div class="pagination-buttons d-flex align-items-center">
                  <button class="page-btn" (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage === 1"> {{"previous" | translate}} </button>

                  <ng-container *ngFor="let page of visiblePageButtons">
                    <button *ngIf="isNumber(page)" class="page-btn" [class.active]="currentPage === page"
                      (click)="onPageClick(page)">
                      {{ page }}
                    </button>

                    <button *ngIf="page === 'left-ellipsis'" class="page-btn" (click)="goToPage(currentPage - 5)">
                      &hellip;
                    </button>

                    <button *ngIf="page === 'right-ellipsis'" class="page-btn" (click)="goToPage(currentPage + 5)">
                      &hellip;
                    </button>
                  </ng-container>

                  <button class="page-btn" (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage === totalPages"> {{ "following" | translate}} </button>
                </div>

              </div>
            </td>
          </tr>

          <td *ngIf="filteredCharges.length != 0" class="m-1">
            <p> {{ filteredCharges.length }} {{"records" | translate}} </p>
          </td>
        </tbody>
      </table>
    </div>

    <!-- Datos resumidos -->
    <div class="summary-data mt-2">
      <div class="summary-item">
        <div class="summary-label"> {{"selectedDevices" | translate}} </div>
        <div class="summary-value">{{summaryData.selectedCount}}</div>
      </div>
      <div class="summary-item">
        <div class="summary-label"> {{"totalConsumption" | translate}} </div>
        <div class="summary-value">{{summaryData.totalConsumption | number:'1.2-2'}} kWh</div>
      </div>
      <div class="summary-item">
        <div class="summary-label"> {{"EstimatedCost" | translate}} </div>
        <div class="summary-value">{{summaryData.estimatedCost | number:'1.2-2'}} €</div>
      </div>
      <div class="summary-item d-flex align-items-center justify-content-between gap-3">
        <!-- Columna de texto -->
        <div class="d-flex flex-column">
          <div class="summary-label">CO₂ {{"co2Saving"| translate}}</div>
          <div class="summary-value" style="color: #7FC823;">
            {{ summaryData.totalConsumption * 0.33999986 | number:'1.2-2' }} kg CO<sub>2</sub>
          </div>
          <span class="pt-2" *ngIf="summaryData.totalConsumption * 0.33999986  > 0">
            {{"equivalent" | translate}} {{ equivalentTrees }} {{"plantedTrees"| translate }} 🌳 </span>
        </div>


        <!-- Imagen -->
        <div class="d-flex flex-column align-items-start">
          <img src="assets/img/orbis/co2_3.png" alt="co2" style="height: 60px; width: 60px;">
        </div>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="summary-actions">

      <div class="dropdown">
        <button class="summary-btn secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          <i class="fas fa-download"></i> {{"export" | translate}}
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" (click)="onExportData('csv')">CSV</a></li>
          <li><a class="dropdown-item" (click)="onExportData('xls')">XLS</a></li>
          <li><a class="dropdown-item" (click)="onExportData('xml')">XML</a></li>
        </ul>
      </div>

    </div>
  </div>
</div>

</div>
  <!--  Modals -->

  <!-- Modal de gráficos -->
<div  class="modal" id="ModalGraphics" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog-centered modal-card-devices m-auto" role="document">
    <div class="w-100 h-100">
      <div class="modal-header" style="background: transparent !important; border-bottom: none;">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"   >
          <span class="text-white" style="font-size: 35px;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-content" *ngIf="showModal">
        <app-card-analytics [dataAnalytics]="dataAnalytics" [connectors]="connectors" [serial]="serial"  [name]="name" ></app-card-analytics>
      </div>
    </div>
  </div>
</div>

<!-- Modal de descarga de historicos -->
<div class="modal" id="modalHistoric" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog-centered modal-card-devices m-auto" role="document">
    <div class="w-100 h-100">
      <div class="modal-header" style="background: transparent !important; border-bottom: none;">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span class="text-white" style="font-size: 35px;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-content" [@zoomIn]="zoomIn" *ngIf="showModalHistorics">
        <app-card-historic [dataHistoric]="dataHistoric" [connectors]="connectors"></app-card-historic>
      </div>
    </div>
  </div>
</div>


<!-- Modal de duplicados -->
<div class="modal fade" id="duplicateModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title ">
          {{ 'warningFWVersion' | translate }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="duplicateModal.toggle()" ></button>
      </div>

      <div class="modal-body">
        <p>{{ 'duplicatedChargersMsg' | translate }}</p>

        <ul class="mb-0 ps-3">
          <li *ngFor="let s of duplicatedDevices">
            {{ s }}
          </li>
        </ul>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-bs-dismiss="modal" (click)="duplicateModal.toggle()" >
          {{ 'accept' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>
